module.exports = __webpack_public_path__ + "img/pro_five_1.bc453518.jpg";